import React from 'react'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useTranslation } from '@/libs/next-lang'
import useAuthorized from './useAuthorized'
import styles from './index.module.less'

interface AuthorizedProps {
  children: React.ReactElement
  code?: string // 定位需要处理的页面
  useOpacity?: boolean // 是否使用透明度
}
const AuthorizedButton = (props: AuthorizedProps) => {
  const { children, useOpacity = true, code } = props
  const { hasPermission } = useAuthorized(code)

  const { t } = useTranslation(['components'])

  const removeFunctionElement = React.cloneElement(children, {
    ...children.props,
    onClick: () => {},
  })

  // eslint-disable-next-line no-nested-ternary
  const tooltipNode = useOpacity ? (
    <Tooltip title={t('components:t15')}>
      <div
        className={classNames(styles['authorized-button'], {
          [styles['authorized-button-opacity']]: useOpacity,
        })}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        {removeFunctionElement}
      </div>
    </Tooltip>
  ) : hasPermission ? (
    removeFunctionElement
  ) : null
  return <>{!hasPermission ? tooltipNode : children}</>
}

export default observer(AuthorizedButton)
